// ##### 25-04-30 Komarov
import { uniLog } from '../../../server/helpers/uniLog';
import { SET_CURRENT_URL } from '../constants';
export const setCurrentUrl = url => async dispatch => {
  // ##### 25-04-30 Komarov
  uniLog('axios:src/Redux/actions/setCurrentUrl.js:url', url);
  dispatch({
    type: SET_CURRENT_URL,
    payload: url,
  });
};
